// extracted by mini-css-extract-plugin
module.exports =  {"boldText":"boldText_qxLN14Sk","bulletList":"bulletList_zKS9N4LX","positiveChange":"positiveChange_kCHCFaVx","negativeChange":"negativeChange_ou6aLa3f"};